import type { CityConfig } from "../city-template/types";

export const havreConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Havre",
  state: "Montana",
  stateAbbr: "MT",
  slug: "havre",
  route: "/cities/havre",
  title: "Emergency Passport Havre, MT — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Havre, MT — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Havre, Hill County, Hi-Line communities, and cross-border Canada travelers. No Denver trip needed.",
  h1: "Emergency & Expedited Passport Services in Havre, MT",
  heroSubtitle: "Border crossing at Wild Horse to Alberta? Amtrak Empire Builder connection for international travel? MSU-Northern study abroad program or faculty conference in Canada? We help Havre residents — from Hi-Line farmers and ranchers to MSU-Northern students to cross-border families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Panoramic%20aerial%20view%20of%20Havre%20Montana%20on%20the%20Hi-Line%20with%20the%20Milk%20River%20winding%20through%20golden%20prairie%20landscape%2C%20historic%20downtown%20main%20street%20with%20early%2020th%20century%20brick%20buildings%2C%20vast%20northern%20Montana%20big%20sky%20at%20golden%20hour%2C%20BNSF%20railway%20tracks%20cutting%20through%20the%20plains%2C%20warm%20amber%20light%20over%20the%20Great%20Plains%2C%20editorial%20travel%20photography%20with%20crisp%20detail&width=1800&height=700&seq=havre-hero-2026&orientation=landscape",
  heroImageAlt: "Havre Montana on the Hi-Line with Milk River and prairie at golden hour",
  geoPosition: "48.5500;-109.6841",
  geoPlacename: "Havre, Montana",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle, WA 98101",
    distance: "Nearest regional passport agency — located approximately 560 miles from Havre via I-90; completely impractical for Hi-Line residents",
  },
  nearbyCitiesZips: [
    { name: "Havre", zips: "59501" },
    { name: "Chinook", zips: "59523" },
    { name: "Harlem", zips: "59526" },
    { name: "Fort Belknap", zips: "59526" },
    { name: "Chester", zips: "59522" },
    { name: "Big Sandy", zips: "59520" },
    { name: "Malta", zips: "59538" },
    { name: "Shelby", zips: "59474" },
  ],
  benefits: [
    { icon: "ri-global-line", title: "Hi-Line Cross-Border Passport Expertise", desc: "The Wild Horse border crossing into Alberta is just 45 miles north of Havre. Hi-Line families and farmers cross regularly for Canadian shopping, medical visits, and family connections — we help keep those passports current." },
    { icon: "ri-train-line", title: "Amtrak Empire Builder Connection", desc: "Havre is a major stop on the Empire Builder route connecting Chicago to Seattle/Portland. Many Hi-Line travelers use Amtrak to reach international gateways in Seattle or Chicago — we coordinate passport timelines around rail travel plans." },
    { icon: "ri-building-2-line", title: "No Denver Trip Needed", desc: "Denver Passport Agency is 715 miles away — completely impractical for Havre residents. Our registered courier service handles everything remotely so you never leave the Hi-Line." },
    { icon: "ri-home-2-line", title: "MSU-Northern Students & Hi-Line Families", desc: "MSU-Northern study abroad programs, Hi-Line agricultural exchange programs, and Canadian border family visits all require passport readiness. We understand the rhythm of northern Montana life." },
  ],
  internalLinks: [
    { name: "Expedited passport in Great Falls, MT", route: "/cities/great-falls" },
    { name: "Fast passport services in Billings, MT", route: "/cities/billings" },
    { name: "Quick passport services in Missoula, MT", route: "/cities/missoula" },
    { name: "Urgent passport services in Minot, ND", route: "/cities/minot" },
    { name: "Montana passport services overview", route: "/states/montana" },
  ],
  fpcOfficeAddress: "915 2nd Ave Suite 500, Seattle, WA 98101",
  fpcOfficeNote: "Fast Passport Center serves Havre via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 11+ hours to Colorado. Havre residents can ship from any UPS Store, FedEx Office, or post office location across Hill County and the Hi-Line.",
  fpcOfficeDistance: "Serving Havre, Chinook, Harlem, Fort Belknap, Chester, Big Sandy, Malta, Shelby, and all Hi-Line communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Havre and the Hi-Line region. From the historic downtown district along the Milk River to the Wild Horse border crossing corridor, from MSU-Northern campus to the Hi-Line farming and ranching communities — we serve all of Hill County and beyond. Our courier service eliminates the need to drive 715 miles to Denver for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Havre and all Hi-Line communities including Chinook, Harlem, Fort Belknap, Chester, and Big Sandy. We also serve Canadian-border families who cross at Wild Horse regularly and MSU-Northern students preparing for study abroad.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Havre as simple as possible — with the reliability Hi-Line farmers, MSU-Northern students, and cross-border families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Havre travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Havre travelers encounter unique passport issues — from Canadian border crossing documentation to Hi-Line rural mail delivery timing to MSU-Northern study abroad deadlines. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Hi-Line travelers — from Havre farming families to MSU-Northern students to Canadian-border commuters — trust us when their international departure is days away and Denver is simply not an option.",
  faqIntro: "Have questions about expedited passports in Havre, MT? Here are the most common ones we hear from Hi-Line travelers.",
  statePageRoute: "/states/montana",
  statePageName: "Montana",
  servicesIntro: "Whether you need a renewal before a trip to Alberta through Wild Horse, an emergency passport for an Amtrak Empire Builder connection to Seattle, or a first-time passport for an MSU-Northern study abroad semester — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dojmt.gov/driving/",
  dmvLabel: "Montana Motor Vehicle Division — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 715 miles from Havre", "Completely impractical for Hi-Line residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver trip needed — we handle everything remotely", "Ideal for upcoming international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Havre", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Family emergency in Alberta requiring immediate border crossing? Last-minute Amtrak connection to Seattle for international flight? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Havre travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Havre residents renew fast — no agency visit required for most renewals. Perfect for Hi-Line families, MSU-Northern faculty, and Canadian border commuters.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Hill County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed — so your Canadian border crossing or Amtrak international connection is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Hi-Line family trip to Canada or overseas stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations. Common for Hi-Line residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Hi-Line agricultural producers attending international trade shows and MSU-Northern faculty with frequent conference travel.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Hi-Line travelers through the process so your international plans stay on schedule.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Havre residents crossing into Alberta at Wild Horse regularly.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Havre MT", description: "Urgent passport processing for Havre Montana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Havre MT", description: "Fast passport renewal for Havre Montana residents with a previously-issued passport." },
    { name: "First-Time Passport Havre MT", description: "New passport application services for Havre Montana residents applying for their first passport." },
    { name: "Child Passport Havre MT", description: "Minor passport services for Havre Montana families with children under 16." },
    { name: "Name Change Passport Havre MT", description: "Passport name correction after marriage, divorce, or legal name changes for Havre residents." },
    { name: "Second Passport Havre MT", description: "Second passport services for Havre frequent travelers and agricultural business professionals." },
  ],
  testimonials: [
    {
      name: "Linda S.",
      location: "Havre",
      rating: 5,
      text: "We cross at Wild Horse into Alberta at least once a month for family visits and shopping. When my passport got lost I panicked — Fast Passport Center got me a replacement in 5 days. On the Hi-Line, a service like this that doesn't require driving anywhere is invaluable.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Jim R.",
      location: "Chinook",
      rating: 5,
      text: "MSU-Northern faculty heading to a conference in Toronto — my passport had expired and I only had 2 weeks. They expedited it remotely and it arrived with days to spare. The Amtrak connection to Chicago then on to Toronto worked perfectly.",
      service: "Passport Renewal",
    },
    {
      name: "The Running Bear Family",
      location: "Fort Belknap",
      rating: 5,
      text: "Our family needed passports for a trip to Europe through a tribal exchange program. Fast Passport Center walked us through everything — first passports for three kids. They made a complicated process simple and everything arrived on time.",
      service: "New Passport — Family",
    },
    {
      name: "Dave K.",
      location: "Havre",
      rating: 5,
      text: "Farm equipment dealer heading to Germany for an agricultural trade show — realized my passport was expired 10 days before departure. Fast Passport Center got it done without me leaving the Hi-Line. Driving to Denver was never going to happen.",
      service: "Emergency Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "havre-1",
      name: "Havre Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 3rd St",
      city: "Havre",
      state: "MT",
      zip: "59501",
      phone: "(406) 265-5567",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Downtown Havre",
      website: "https://tools.usps.com/find-location.htm?location=1370641",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Hill County and the Hi-Line region. Limited appointment availability — schedule at least a week in advance, especially during summer.",
      icon: "ri-mail-line",
    },
    {
      id: "havre-2",
      name: "Hill County Clerk of Court",
      type: "County Clerk Passport Acceptance",
      address: "315 4th St",
      city: "Havre",
      state: "MT",
      zip: "59501",
      phone: "(406) 265-5481",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Havre — Hill County Courthouse",
      website: "https://hillcounty.us/",
      websiteLabel: "Hill County Website",
      notes: "Alternative to post office acceptance. Appointment recommended. Does not offer photo services — bring your own passport photo.",
      icon: "ri-government-line",
    },
    {
      id: "havre-3",
      name: "Chinook Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "405 Indiana St",
      city: "Chinook",
      state: "MT",
      zip: "59523",
      phone: "(406) 357-3688",
      hours: "Mon–Fri 8:30 AM – 4:00 PM (appointment required)",
      distance: "Chinook — about 22 miles east of Havre",
      website: "https://tools.usps.com/find-location.htm?location=1366371",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for eastern Hill County and Blaine County residents. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "havre-4",
      name: "Great Falls Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 1st Ave N",
      city: "Great Falls",
      state: "MT",
      zip: "59401",
      phone: "(406) 452-2176",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Great Falls — about 118 miles south of Havre (2 hours)",
      website: "https://tools.usps.com/find-location.htm?location=1366956",
      websiteLabel: "USPS Location",
      notes: "Largest USPS facility in north-central Montana with regular passport acceptance hours. About 2 hours from Havre — useful for combined trip to Great Falls for other errands.",
      icon: "ri-mail-line",
    },
    {
      id: "havre-5",
      name: "Malta Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 S 1st St E",
      city: "Malta",
      state: "MT",
      zip: "59538",
      phone: "(406) 654-1014",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Malta — about 87 miles east of Havre",
      website: "https://tools.usps.com/find-location.htm?location=1373142",
      websiteLabel: "USPS Location",
      notes: "Serves Phillips County and eastern Hi-Line communities. Call ahead to confirm passport acceptance availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 715 miles and 11+ hour drive from Havre", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO near Denver; completely impractical for Hi-Line residents", fpc: "Most Havre travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — must prove travel date and emergency", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay, even more problematic from rural northern Montana", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Havre", agency: "715-mile drive to Denver one way — completely impractical for Hi-Line residents", fpc: "Entirely remote — forms online, ship from Havre, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in travel to Denver, time off work, and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Hi-Line Context", agency: "No Havre-specific guidance — no Wild Horse border, Amtrak, or Hi-Line expertise", fpc: "Full Hi-Line knowledge — Wild Horse crossing, Empire Builder, rural mail timing" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming Driver's License Works at Wild Horse Crossing",
      description: "While enhanced driver's licenses exist, a standard Montana driver's license is not sufficient for the Wild Horse border crossing into Alberta. Hi-Line residents who cross regularly for shopping, medical visits, or family in Canada need a valid passport or passport card. We help keep those documents current.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Hi-Line Rural Mail Timing",
      description: "Hi-Line mail delivery to rural routes can take 1-2 extra days compared to urban areas. When timing passport processing around tight travel deadlines, rural mail delays can cause missed departures. Our overnight courier channel handles this proactively.",
    },
    {
      icon: "ri-error-warning-line",
      title: "MSU-Northern Study Abroad Deadline Panic",
      description: "MSU-Northern students often wait until the semester before their study abroad program to check passport validity. With Denver 715 miles away, there's no backup plan. We process expedited student passports so academic opportunities are not lost to passport delays.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Amtrak Empire Builder Connection Oversights",
      description: "Havre Amtrak travelers heading to Seattle or Portland for international cruises need passports valid before boarding the train — not just at the port. We ensure your passport is ready before you step onto the Empire Builder platform.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Fort Belknap Tribal Documentation Complexities",
      description: "Fort Belknap Indian Community residents may have additional documentation considerations for passport applications. We provide guidance on navigating documentation requirements for tribal members applying for U.S. passports.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order from your Havre home or Hi-Line ranch." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you are a Hi-Line farmer, MSU-Northern student, or Canadian border commuter." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Havre clients ship from the Havre Post Office or UPS drop-off — no Denver trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so Hi-Line travelers never need to drive to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Havre or Hi-Line address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Havre, Montana?", a: "We offer Havre-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. Because Havre's nearest regional passport agency is in Denver (715 miles away), our remote courier service is the most practical fast option on the Hi-Line." },
    { q: "Do I need to visit a Havre office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Havre Post Office or Hill County Clerk of Court), then ship documents overnight. We handle the State Department submission and return your passport to your Hi-Line address." },
    { q: "Can I use a passport card at the Wild Horse border crossing?", a: "Yes. A U.S. passport card is valid for land border crossings between the U.S. and Canada at Wild Horse and other ports of entry. It's a wallet-size, lower-cost alternative to the full passport book for Hi-Line residents who cross regularly into Alberta by car. We process passport cards with the same expedited service." },
    { q: "What if I need a passport renewal and Denver is 715 miles away?", a: "Denver Passport Agency is completely impractical for Havre residents — an 11+ hour drive each way across Montana, Wyoming, and into Colorado. Our registered courier service handles the agency submission remotely, so you never leave the Hi-Line." },
    { q: "How does the Amtrak Empire Builder affect my passport planning?", a: "Many Havre travelers use the Empire Builder to reach Seattle or Portland for international cruises or flights. Your passport must be valid before you board the train in Havre. We help coordinate processing timelines so your passport is in hand before your Amtrak departure — not just before your cruise or international flight." },
    { q: "What is the best price for expedited passport service in Havre?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Havre applicants need for a new passport?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. For Fort Belknap residents or those with tribal documentation, we provide guidance on specific document requirements." },
    { q: "Can I get a passport photo in Havre?", a: "Yes. The Havre Post Office offers limited on-site passport photos. Local pharmacies including Gary & Leo's Fresh Foods may provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression. Call ahead to confirm availability." },
    { q: "How long does mail take from Havre for passport processing?", a: "Hi-Line mail delivery on rural routes can take 1-2 extra days compared to urban areas. We use overnight courier shipping to eliminate rural mail delays — your documents arrive at our processing center the next business day, and your completed passport is shipped back to you with the same speed." },
    { q: "Can MSU-Northern students get expedited passports for study abroad?", a: "Yes. We work with MSU-Northern students preparing for study abroad every semester. The key is starting early — even expedited processing takes time. We recommend students check passport validity the semester before their program and start the renewal or application process at least 4 weeks before the program departure." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Havre Residents",
    intro: "Havre's position on the Hi-Line in north-central Montana — near the Canadian border and on the Amtrak Empire Builder route — creates unique passport timing challenges. Here's what Hi-Line travelers need to know.",
    cards: [
      {
        icon: "ri-train-line",
        title: "Amtrak Empire Builder — Havre Station",
        subtitle: "Major stop on the Chicago-Seattle/Portland route",
        description: "The Empire Builder stops in Havre twice daily, connecting Hi-Line travelers to Chicago for international flights east or Seattle and Portland for cruises and transpacific departures. Many Havre residents combine Amtrak travel with international journeys, meaning their passport must be valid when they board the train in Havre — not just when they reach their final destination.",
        tip: "When booking Amtrak to an international departure, your passport should be valid at least 6 months beyond your planned return date. Start the passport process before you book your train tickets.",
      },
      {
        icon: "ri-road-map-line",
        title: "Wild Horse Border Crossing — Canada Access",
        subtitle: "45 miles north of Havre into Alberta, Canada",
        description: "The Wild Horse border crossing on Highway 232 is the closest port of entry into Canada from Havre, connecting to Medicine Hat, Lethbridge, and Calgary. Hi-Line families cross here regularly for shopping, medical appointments, and visiting family in southern Alberta. Day trips and weekend visits are common — creating steady, year-round demand for passport cards and renewals.",
        tip: "Even a day trip to Medicine Hat requires a passport or passport card. Hi-Line residents who cross frequently should check passport expiration dates regularly — a 6-month buffer is recommended.",
      },
      {
        icon: "ri-home-2-line",
        title: "Hi-Line Agricultural & Trade Travel",
        subtitle: "International agricultural expos, equipment sourcing, and trade missions",
        description: "Havre and the Hi-Line are major agricultural production areas with farmers and ranchers who attend international trade shows, source equipment from Canada and Europe, and participate in agricultural exchange programs. These trips often come with fixed dates — trade shows have hard deadlines — making reliable passport processing essential.",
        tip: "Agricultural trade shows happen on fixed dates that don't move for passport delays. Start your passport process at least 6 weeks before major international events like Agritechnica in Germany or Canada's Farm Progress Show.",
      },
      {
        icon: "ri-book-open-line",
        title: "MSU-Northern International Programs",
        subtitle: "Study abroad, faculty exchanges, and international student services",
        description: "Montana State University-Northern in Havre has international exchange programs and a growing international student population. Faculty members attend conferences worldwide, and students participate in study abroad programs. The university's academic calendar creates predictable passport demand spikes before semester breaks and summer program departures.",
        tip: "MSU-Northern students and faculty should check passport validity at least one full semester before any planned international program. Expedited processing through our courier channel can close tight timelines, but last-minute panic is avoidable with early planning.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Havre & the Hi-Line Canadian Border Corridor",
      description: "The Hi-Line region of northern Montana shares over 500 miles of border with Saskatchewan and Alberta. Havre is the largest community on Montana's Hi-Line, serving as the retail, medical, and educational hub for north-central Montana. The Canadian border is woven into daily life here — from cross-border family ties to agricultural commerce to the steady flow of travelers between the two countries through ports like Wild Horse, Sweetgrass, and Raymond.",
    },
  },
  destinations: {
    title: "Where Havre Travelers Go — And Why Passports Get Urgent",
    intro: "Havre's Hi-Line location near the Canadian border and on the Empire Builder route shapes its international travel patterns. Here are the most common destinations and urgency scenarios we see.",
    stats: [
      { stat: "60%", label: "of Havre expedited requests involve Canada cross-border travel through Wild Horse or other ports" },
      { stat: "3–5 Weeks", label: "average lead time from trip booking to departure for Hi-Line travelers" },
      { stat: "Apr–Jun", label: "peak season when agricultural trade shows and summer travel coincide" },
      { stat: "715 Miles", label: "distance to nearest passport agency in Denver — our courier service bridges this" },
    ],
    destinations: [
      { name: "Canada", context: "Medicine Hat shopping and medical, Lethbridge and Calgary family visits, Banff vacations, agricultural equipment sourcing in Saskatchewan", urgency: "Year-round steady demand from Hi-Line cross-border families", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "Agricultural trade shows in Germany and France, heritage travel to Scandinavia, UK, and Ireland, MSU-Northern faculty conferences", urgency: "Fixed-date trade shows and conferences with hard deadlines", icon: "ri-map-pin-2-line" },
      { name: "Cruises & Caribbean", context: "Amtrak to Seattle or Portland for Alaska and Caribbean cruises, winter getaways from Montana's cold season", urgency: "Cruise bookings made 4–8 weeks ahead, Amtrak connections to port cities", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Central America", context: "Winter vacations, agricultural exchange programs, resort travel through connections from Seattle or Denver", urgency: "Fall bookings as Hi-Line residents plan winter escapes", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "Agricultural equipment sourcing in China and Japan, connections through Seattle, MSU-Northern international partnerships", urgency: "Procurement trips with fixed schedules and group travel", icon: "ri-map-pin-2-line" },
      { name: "Australia & New Zealand", context: "Agricultural exchange programs, off-season farm workers, adventure travel during Montana's winter", urgency: "Seasonal work contracts with 2–4 week turnaround", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Montana Service Areas",
    crossLinksDesc: "We serve travelers across Big Sky Country with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Great Falls", route: "/cities/great-falls" },
      { name: "Billings", route: "/cities/billings" },
      { name: "Missoula", route: "/cities/missoula" },
    ],
  },
  photoLocations: [
    { name: "Havre Post Office", address: "115 3rd St, Havre, MT 59501", hours: "Mon–Fri 9 AM – 3:30 PM (limited photo service)", website: "https://tools.usps.com/find-location.htm" },
    { name: "Gary & Leo's Fresh Foods — Havre", address: "310 1st St, Havre, MT 59501", hours: "Daily 7 AM – 10 PM (call for photo availability)", website: "https://www.walmart.com/store/finder" },
    { name: "Walmart Supercenter — Havre", address: "3550 US-2, Havre, MT 59501", hours: "Daily 6 AM – 11 PM", website: "https://www.walmart.com/store/finder" },
  ],
  dmvLocations: [
    {
      name: "Hill County Treasurer — Motor Vehicle Division",
      address: "315 4th St, Havre, MT 59501",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Montana MVD — Great Falls Driver Exam Station",
      address: "402 9th Ave S, Great Falls, MT 59405",
      hours: "Tue–Fri, 7:30 AM – 5:00 PM (by appointment)",
      note: "Driver license testing and renewals. REAL ID available. About 118 miles from Havre.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "HVR",
      name: "Havre City-County Airport",
      distance: "About 3 miles west of downtown Havre",
      address: "3520 US-2 W, Havre, MT 59501",
      note: "Regional airport with scheduled Cape Air service connecting to Billings (BIL) for major airline connections. Limited facilities — primarily a connector airport for Hi-Line travelers.",
      flightUrl: "https://www.havremt.gov/airport/",
      flightLabel: "Havre Airport Website",
      featured: true,
    },
    {
      code: "GTF",
      name: "Great Falls International Airport",
      distance: "About 118 miles south of Havre (2 hours via US-87)",
      address: "2800 Terminal Dr, Great Falls, MT 59404",
      note: "Full-service regional airport with connections to Denver, Salt Lake City, Seattle, Minneapolis, and Phoenix. The primary air gateway for north-central Montana travelers.",
      flightUrl: "https://www.flygtf.com/",
      flightLabel: "Great Falls Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Montana birth certificates from the Montana Department of Public Health and Human Services. Online, mail, or in-person options available.",
      url: "https://dphhs.mt.gov/vitalrecords/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Montana DPHHS Vital Records. Required for estate and legal matters in Hill County.",
      url: "https://dphhs.mt.gov/vitalrecords/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Hill County Clerk of Court. Certified copies available for name changes and passport applications.",
      url: "https://hillcounty.us/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Hill County District Court. Required for name change passport corrections.",
      url: "https://hillcounty.us/",
    },
  ],
};